import { ResponseDataGet } from "../../../../models/responseDataGet";
import { ResponseDataTest } from "../../../../models/responseDataTest";
import { agroApi } from "../../api";
import { BasicHbFilter } from "../../../../models/filters/basicHbFilter";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { Paths } from "../../../../paths";

export const typesOfPesticides = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTypesOfPesticides: builder.query<ResponseDataGet<EntDirectoryInfoName>, BasicHbFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.typesOfPesticides }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getTypesOfFertilizersById: builder.query<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typesOfPesticides }/${ id }`,
		method: 'GET'
	  })
	}),
	addTypesOfPesticides: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.typesOfPesticides }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editTypesOfPesticides: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.typesOfPesticides }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteTypesOfPesticides: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typesOfPesticides }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddTypesOfPesticidesMutation,
  useEditTypesOfPesticidesMutation,
  useDeleteTypesOfPesticidesMutation,
  useLazyGetTypesOfPesticidesQuery
} = typesOfPesticides;
